export const DollarCircleIcon = ({
  strokeColor = "var(--color-icon-bright)",
  ...props
}: any) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g id="vuesax/outline/dollar-circle">
      <g id="dollar-circle">
        <path
          id="Vector"
          d="M8.93344 11.6134H7.2601C6.16677 11.6134 5.2801 10.6934 5.2801 9.56005C5.2801 9.28672 5.50677 9.06005 5.7801 9.06005C6.05344 9.06005 6.2801 9.28672 6.2801 9.56005C6.2801 10.1401 6.7201 10.6134 7.2601 10.6134H8.93344C9.36677 10.6134 9.72677 10.2267 9.72677 9.76005C9.72677 9.18005 9.5201 9.06672 9.1801 8.94672L6.49344 8.00005C5.97344 7.82005 5.27344 7.43339 5.27344 6.24005C5.27344 5.21339 6.0801 4.38672 7.06677 4.38672H8.7401C9.83344 4.38672 10.7201 5.30672 10.7201 6.44005C10.7201 6.71339 10.4934 6.94005 10.2201 6.94005C9.94677 6.94005 9.7201 6.71339 9.7201 6.44005C9.7201 5.86005 9.2801 5.38672 8.7401 5.38672H7.06677C6.63344 5.38672 6.27344 5.77339 6.27344 6.24005C6.27344 6.82005 6.4801 6.93339 6.8201 7.05339L9.50677 8.00005C10.0268 8.18005 10.7268 8.56672 10.7268 9.76005C10.7201 10.7801 9.9201 11.6134 8.93344 11.6134Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M8 12.5C7.72667 12.5 7.5 12.2733 7.5 12V4C7.5 3.72667 7.72667 3.5 8 3.5C8.27333 3.5 8.5 3.72667 8.5 4V12C8.5 12.2733 8.27333 12.5 8 12.5Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M8.00016 15.1673C4.04683 15.1673 0.833496 11.954 0.833496 8.00065C0.833496 4.04732 4.04683 0.833984 8.00016 0.833984C11.9535 0.833984 15.1668 4.04732 15.1668 8.00065C15.1668 11.954 11.9535 15.1673 8.00016 15.1673ZM8.00016 1.83398C4.60016 1.83398 1.8335 4.60065 1.8335 8.00065C1.8335 11.4007 4.60016 14.1673 8.00016 14.1673C11.4002 14.1673 14.1668 11.4007 14.1668 8.00065C14.1668 4.60065 11.4002 1.83398 8.00016 1.83398Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
